import React from "react";
import { styled } from "styled-components";
import ColorField from "../ColorField";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Separator = styled.hr`
  width: 100%;
`;

export default function PrimaryThemeForm() {
  return (
    <Container>
      <h2>Primary</h2>
      <ColorField
        label="Background"
        name="primary.color"
        info="Modal, bottom sheets background"
        infoId="primaryColor"
      />
      <Separator />
      <h3>Content</h3>
      <ColorField label="Default" name="primary.content.default" />
      <ColorField
        label="Danger"
        name="primary.content.danger"
        info="Delete address modal, Delete order modal"
        infoId="primaryContentDanger"
      />
      <ColorField
        label="Success"
        name="primary.content.success"
        info="Order card success state"
        infoId="primaryContentSuccess"
      />
      <ColorField
        label="Warning"
        name="primary.content.warning"
        info="Wolt delivery note text"
        infoId="primaryContentSuccess"
      />
      <ColorField
        label="Alternative 1"
        name="primary.content.alt_1"
        info="Modal, bottom sheets description"
        infoId="primaryContentAlt1"
      />
      <Separator />
      <h3>Highlights</h3>
      <ColorField
        label="Default"
        name="primary.highlights.default"
        info="Advance pricing tag, checkbox & radio button checked color"
        infoId="primaryHighlightsDefault"
      />
      <ColorField
        label="Alternative 1"
        name="primary.highlights.alt_1"
        info="Order pickup time selection"
        infoId="primaryHighlightsAlt1"
      />
      <Separator />
      <h3>Buttons</h3>
      <h4>Default</h4>
      <ColorField
        label="Background"
        name="primary.buttons.default.color"
        info="Add to cart button background"
        infoId="primaryButtonDefaultBackground"
      />
      <ColorField
        label="Content"
        name="primary.buttons.default.content"
        info="Add to cart button text"
        infoId="primaryButtonDefaultContent"
      />
      <ColorField
        label="Disabled Background"
        name="primary.buttons.default.disabled"
        info="Add to cart button disabled background"
        infoId="primaryButtonDefaultDisabled"
      />
      <h4>Alternative 1</h4>
      <ColorField label="Background" name="primary.buttons.alt_1.color" />
      <ColorField label="Content" name="primary.buttons.alt_1.content" />
      <h4>Alternative 2</h4>
      <ColorField label="Background" name="primary.buttons.alt_2.color" />
      <ColorField label="Content" name="primary.buttons.alt_2.content" />
      <h4>Alternative 3</h4>
      <ColorField
        label="Background"
        name="primary.buttons.alt_3.color"
        info="Mark as picked up slider background"
        infoId="primaryButtonsAlt3Background"
      />
      <ColorField
        label="Content"
        name="primary.buttons.alt_3.content"
        info="Mark as picked up slider text"
        infoId="primaryButtonsAlt3Content"
      />
      <ColorField
        label="Accent"
        name="primary.buttons.alt_3.accent"
        info="Mark as picked up slider thumb color"
        infoId="primaryButtonsAlt3Accent"
      />
      <Separator />
      <h3>Surfaces</h3>
      <h4>Default</h4>
      <ColorField label="Background" name="primary.surfaces.default.color" />
      <ColorField
        label="Content - Default"
        name="primary.surfaces.default.content.default"
      />
      <h4>Alternative 1</h4>
      <ColorField label="Background" name="primary.surfaces.alt_1.color" />
      <h4>Alternative 2</h4>
      <ColorField label="Background" name="primary.surfaces.alt_2.color" />
    </Container>
  );
}
